import React, { FC, ReactNode } from 'react';
import Title from '@/apps/appCreator/components/Title';
import style from './style.module.scss';

type TItem = {
  name: ReactNode;
  disclaimerLink?: ReactNode;
  tooltip?: ReactNode;
  className?: string;
};

const Item: FC<TItem> = ({
  name,
  disclaimerLink,
  tooltip,
  children,
  className,
}) => (
  <tr className={className}>
    <td>
      <div>
        {name}
        {disclaimerLink && <sup>{disclaimerLink}</sup>}
        {tooltip}
      </div>
    </td>
    <td>{children}</td>
  </tr>
);

type TCarDiscounts = {
  total: ReactNode;
  className?: string;
};

const CarDiscounts: FC<TCarDiscounts> = ({ children, total, className }) => {
  return (
    <div className={className}>
      <Title className="mb-3" tag="h2">
        подробно о цене
      </Title>
      <table className={style.list}>
        <tbody>{children}</tbody>
        <tfoot>
          <tr>
            <td>Ваша доплата составит</td>
            <td>{total}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export { CarDiscounts as default, Item };
